import { I } from "./primitives";

export function Sidebar({ route, setRoute, problemCount, expanded, setExpanded }) {
  const items = [
    { id: "dashboard", label: "Dashboard", icon: I.dashboard, badge: problemCount },
    { id: "notifications", label: "Pengaturan Notifikasi", icon: I.bell },
    { id: "logs", label: "Log Notifikasi", icon: I.log },
  ];
  return (
    <aside className="sidebar" data-expanded={expanded}>
      <div className="sidebar-brand">
        <div className="sidebar-brand-mark" aria-hidden="true" />
        {expanded && <span className="sidebar-brand-name">Monibot</span>}
        {expanded && (
          <button className="sidebar-toggle" onClick={() => setExpanded(false)} title="Collapse">
            <I.chevron style={{ transform: "rotate(180deg)" }} />
          </button>
        )}
        {!expanded && (
          <button className="sidebar-toggle" onClick={() => setExpanded(true)} title="Expand" style={{ marginLeft: 0 }}>
            <I.chevron />
          </button>
        )}
      </div>
      <nav className="sidebar-nav">
        {expanded && <div className="sidebar-section">Workspace</div>}
        {items.map((it) => (
          <button
            key={it.id}
            className="nav-item"
            aria-current={route === it.id ? "page" : undefined}
            onClick={() => setRoute(it.id)}
            title={!expanded ? it.label : undefined}
          >
            <span className="nav-item-icon"><it.icon /></span>
            {expanded && <span>{it.label}</span>}
            {expanded && it.badge > 0 && (
              <span className="nav-item-badge">{it.badge}</span>
            )}
            {!expanded && it.badge > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  width: 8,
                  height: 8,
                  borderRadius: 4,
                  background: "var(--crit)",
                }}
              />
            )}
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="avatar">DS</div>
        {expanded && (
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="sidebar-user-name">Danang S.</div>
            <div className="sidebar-user-role">DevOps Lead</div>
          </div>
        )}
      </div>
    </aside>
  );
}

export function Header({ title, sub, lastTick, theme, setTheme, statusCounts, statusFilter, setStatusFilter, right }) {
  return (
    <header className="header">
      <div>
        <div className="header-title">{title}</div>
        {sub && <div className="header-sub">{sub}</div>}
      </div>
      <div className="header-spacer" />
      {statusCounts && (
        <div className="status-counts" role="group" aria-label="Filter status">
          <button
            data-active={statusFilter === "all"}
            onClick={() => setStatusFilter("all")}
            title="Semua server"
          >
            <span style={{ color: "var(--text-3)" }}>All</span>
            <span>{statusCounts.total}</span>
          </button>
          <button
            data-active={statusFilter === "crit"}
            onClick={() => setStatusFilter(statusFilter === "crit" ? "all" : "crit")}
            title="Over threshold"
          >
            <span className="swatch crit" /><span>{statusCounts.crit}</span>
          </button>
          <button
            data-active={statusFilter === "warn"}
            onClick={() => setStatusFilter(statusFilter === "warn" ? "all" : "warn")}
            title="Mendekati threshold"
          >
            <span className="swatch warn" /><span>{statusCounts.warn}</span>
          </button>
          <button
            data-active={statusFilter === "ok"}
            onClick={() => setStatusFilter(statusFilter === "ok" ? "all" : "ok")}
            title="Aman"
          >
            <span className="swatch ok" /><span>{statusCounts.ok}</span>
          </button>
        </div>
      )}
      {lastTick && (
        <div className="live-pill" title="Real-time update interval">
          <span className="live-dot" />
          <span>Live · 3s</span>
          <span style={{ color: "var(--text-4)" }}>·</span>
          <span style={{ color: "var(--text-3)" }}>{lastTick}</span>
        </div>
      )}
      {right}
      <button
        className="btn-icon bare"
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      >
        {theme === "dark" ? <I.sun /> : <I.moon />}
      </button>
    </header>
  );
}
